import { render } from "./Tenants.vue?vue&type=template&id=78414182&scoped=true&ts=true"
import script from "./Tenants.vue?vue&type=script&lang=ts"
export * from "./Tenants.vue?vue&type=script&lang=ts"

import "./Tenants.vue?vue&type=style&index=0&id=78414182&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78414182"]])

export default __exports__